import React from 'react';
import ProjectList from '../components/projects/ProjectList';

const ProjectsPage = () => {
    return <ProjectList />;
};

export default ProjectsPage;